
import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import useRedirect from 'hooks/use-redirect'
import AllowCookies from 'components/allow-cookies'
import textServices from 'services/text-services'
import { Back } from 'theme/theme'
import { Facebook, Google, Guest, SignUp, SignIn } from 'components/start'
import ErrorView from 'components/error-view'
import { useSession } from '../../contexts/session-context'
import { LoaderContext } from '../../contexts/loader-context'
import { FormContainer } from '../../theme/start'
import { TextStart, TitleStart } from './text.style'
dayjs.extend(customParseFormat)
export interface FormValues {
  code: string
}

const Start = () => {
  const [session, { setError, setSession, setUser }] = useSession()
  const history = useHistory()
  const [{ url }, { redirect }] = useRedirect();
  const [firebaseError, setFirebaseError] = useState('')
  const [loginError, setLoginError] = useState<number | undefined>()
  const [allowCookies, setAllowCookies] = useState<{ callback: () => void, isAllow: boolean }>()
  const { setHead } = useContext(LoaderContext)
  const Buttons: { [key: string]: any } = {
    facebook: (
      <Facebook
        setSession={setSession}
        setUser={setUser}
        setLoginError={setLoginError}
        setError={setError}
        setFirebaseError={setFirebaseError}
        setAllowCookies={setAllowCookies}
      />
    ),
    google: (
      <Google
        setSession={setSession}
        setUser={setUser}
        setLoginError={setLoginError}
        setError={setError}
        setFirebaseError={setFirebaseError}
        setAllowCookies={setAllowCookies}
      />
    ),
    guest: <Guest />,
    signUp: <SignUp />,
    signIn: <SignIn />
  }

  const buttonsNotSocial = THEME_CONFIG.buttonsStart.filter((button) => button === 'signUp' || button === 'signIn' || button === 'guest')
  const buttonsSocial = THEME_CONFIG.buttonsStart.filter((button) => button === 'facebook' || button === 'google')


  useEffect(() => {
    setHead(true)
  }, [])

  useEffect(() => {
    if (session.user) {
      if (url) return redirect()
      history.push('/home')
    }
  }, [session.user])

  const formContainerClasses = `my-8 flex-col w-full transition-colors duration-300 items-center px-7 sm:max-w-sm sm:items-center`

  if (allowCookies?.isAllow) {
    return (
      <AllowCookies onSubmit={allowCookies?.callback} />
    )
  }

  if (loginError) {
    return <ErrorView code={loginError as number} buttonMenu={() => setLoginError(null)} onRetry={() => setLoginError(null)} />
  }

  if (firebaseError) {
    return <ErrorView code={firebaseError as unknown as number} buttonMenu={() => setFirebaseError('')} onRetry={(code) => +code === 107 ? history.push('/login') : setFirebaseError('')} />
  }

  return (
    <section className="flex-1 py-0 flex flex-col items-center din large-screen-padding" style={{ maxHeight: 1080 }}>
      {textServices.findByText('start/title/html',
        <Back className={`flex flex-col flex-1 w-full justify-center sm:items-center`}>
          <div className="w-full h-full flex items-center justify-center bg-no-repeat bg-center bg-contain" style={{ backgroundImage: `url(${`${AZURE_BASE_URL}/fondo-inicial.svg`})` }}>
            <TitleStart className="text-4xl font-normal text-center ">
              {textServices.findByText('start/title/h1', <>¿Listo para ser <br /> parte del equipo? <br /> <span className="font-semibold">¡Regístrate!</span></>)}
            </TitleStart>
          </div>
        </Back>
      )}
      <FormContainer
        className={formContainerClasses}
      >
        <div className=" flex flex-col items-center gap-4">
          <div className='flex w-full items-center justify-center gap-4 py-4 saira font-bold text-sm'>
            <TextStart>{textServices.findByText('start/social', 'ENTRA CON:')}</TextStart> {buttonsSocial.map((button, index) => {
              return <span className={`bg-white rounded-full border-2 border-black`} key={index}>{Buttons[button]}</span>
            })}
          </div>
          {buttonsNotSocial.map((button, index) => {
            return <div key={index} className={`w-full sm:w-72`}>{Buttons[button]}</div>
          })}
        </div>
      </FormContainer>
    </section>
  )
}

export default Start
